var _effectorFileName = "/builds/gmini/front-ui-kit/src/CircularProgress/CircularProgress.tsx";
import { CircleWrapper, CircularProgressWrapper, SVGWrapper } from './CircularProgress.styled';
import { jsx as _jsx } from "react/jsx-runtime";
export const CircularProgress = ({
  color = 'primary',
  disableShrink = false,
  size = 40,
  thickness = 3.6,
  ...other
}) => /*#__PURE__*/_jsx(CircularProgressWrapper, {
  color: color,
  role: "progressbar",
  style: {
    width: size,
    height: size
  },
  ...other,
  children: /*#__PURE__*/_jsx(SVGWrapper, {
    viewBox: "22 22 44 44",
    children: /*#__PURE__*/_jsx(CircleWrapper, {
      cx: 44,
      cy: 44,
      r: 20.2 + (3.6 - thickness) / 2,
      fill: "none",
      strokeWidth: thickness,
      disableShrink: disableShrink
    })
  })
});